import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import { articlesSousMenuItem, matieresSousmenuItem, ressourcesSousMenuItem } from './sous-menu-items.constantes';

export const donneesMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-book1', 'Données', [
  articlesSousMenuItem,
  matieresSousmenuItem,
  ressourcesSousMenuItem,
]);
